/* Atelier product-domain helpers. No catalog mutation or tracking. */
(function(root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.AtelierPDP = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function() {
  'use strict';
  function productURL(path, base) {
    if (typeof path !== 'string' || !/^\/(?!\/)/.test(path) || /[\\\x00-\x1f]/.test(path)) throw new Error('Invalid product path');
    const u = new URL(path, base), current = new URL(base);
    if (u.origin !== current.origin || !/\/products\/[^/]+\/?$/.test(u.pathname)) throw new Error('Invalid product URL');
    return u;
  }
  function quickViewURL(path, base) {
    const target = productURL(path, base), current = new URL(base);
    const preview = current.searchParams.get('preview_theme_id');
    if (preview && /^\d+$/.test(preview)) target.searchParams.set('preview_theme_id', preview);
    return target.href;
  }
  function selectionURL(path, base, section, ids) {
    const target = productURL(path, base), current = new URL(base);
    if (!section || !Array.isArray(ids) || ids.some(id => !/^\d+$/.test(String(id)))) throw new Error('Invalid option selection');
    const handle = target.pathname.split('/products/')[1];
    if (!current.pathname.endsWith('/products/' + handle)) current.pathname = target.pathname;
    current.searchParams.delete('variant'); current.searchParams.delete('option_values');
    current.searchParams.set('section_id', section);
    if (ids.length) current.searchParams.set('option_values', ids.join(','));
    current.hash = '';
    return current.href;
  }
  function variantURL(base, state) {
    const u = new URL(base); u.searchParams.delete('section_id'); u.searchParams.delete('variant'); u.searchParams.delete('option_values');
    if (state.id) u.searchParams.set('variant', String(state.id));
    else if (state.selected?.length) u.searchParams.set('option_values', state.selected.join(','));
    return u.href;
  }
  function ruleOf(rule = {}) {
    const min = Math.max(1, Number(rule.min) || 1), step = Math.max(1, Number(rule.increment) || 1);
    const max = rule.max === null || rule.max === undefined || rule.max === '' ? Infinity : Number(rule.max);
    return { min, step, max: Number.isFinite(max) ? Math.max(0, max) : Infinity };
  }
  function validQuantity(value, rule) {
    const n = Number(value), r = ruleOf(rule);
    return Number.isSafeInteger(n) && n >= r.min && n <= r.max && (n - r.min) % r.step === 0;
  }
  function stepQuantity(value, direction, rule) {
    const r = ruleOf(rule), n = validQuantity(value, rule) ? Number(value) : r.min;
    const max = Number.isFinite(r.max) ? r.min + Math.floor((r.max - r.min) / r.step) * r.step : Infinity;
    return Math.max(r.min, Math.min(max, n + (direction < 0 ? -1 : 1) * r.step));
  }
  return { productURL, quickViewURL, selectionURL, variantURL, ruleOf, validQuantity, stepQuantity };
});
